/** biome-ignore-all lint/suspicious/noArrayIndexKey: Because */
'use client';

import { UTCDate } from '@date-fns/utc';
import { type HTMLAttributes, useMemo } from 'react';
import { useGetApiRssFeed } from '@/api/backoffice/rss/rss';
import type { RssFeed } from '@/api/backoffice-schemas';
import NewsFeedCard from '@/components/cards/newsFeedCard';
import SkeletonNews from '@/components/skeletons/rss';
import type { Game } from '@/constants/game.const';
import { cn } from '@/utils/cn';
import { getRssFeedGameFromGame } from '@/utils/gameMappers';

export type NewsFeedBannerProps = HTMLAttributes<HTMLDivElement> & {
  game?: Game;
};

export const NewsFeedBanner = ({
  className,
  game,
  ...props
}: NewsFeedBannerProps) => {
  const { data, isLoading } = useGetApiRssFeed();
  const gameFilter = useMemo(() => getGameFilter(game), [game]);

  return (
    <div
      className={cn(
        'flex w-full flex-col gap-4 rounded-lg bg-medium-gray p-4',
        className
      )}
      {...props}
    >
      <div className="flex flex-row items-center justify-start">
        <p className="font-semibold text-base">News Feed</p>
      </div>
      {isLoading &&
        Array.from({ length: 10 }, (_, index) => <SkeletonNews key={index} />)}

      {!isLoading &&
        data?.data
          .filter(gameFilter)
          .sort(
            (a, b) =>
              new UTCDate(b.date as string).getTime() -
              new UTCDate(a.date as string).getTime()
          )
          .slice(0, 10)
          .map((item, index) => <NewsFeedCard data={item} key={index} />)}
    </div>
  );
};

function getGameFilter(game?: Game) {
  if (!game) {
    return () => true;
  }
  const rssFeedGame = getRssFeedGameFromGame(game);
  if (!rssFeedGame) {
    return () => true;
  }
  return (item: RssFeed) => item.game === rssFeedGame;
}
